import initialState from "./initialState";
import {
    FETCHING_VENDORS_FROM_API,
    GET_FILTER_FAIL,
    GET_FILTER_SUCCESS,
    GET_VENDORS_FAIL,
    GET_VENDORS_SUCCESS,
    RESET_FILTER_ON_CLEAR_BUTTON_CLICK,
    TOGGLE_BCP_FUNCTION_FILTER,
    TOGGLE_INHERENT_RISK_FILTER,
    TOGGLE_RESIDUAL_RISK_FILTER,
    TOGGLE_EVENT_FILTER
} from "../../actions/vendors/vendorConcentrationMapAction";

export default function vendorConcentrationMapReducer(state = initialState, action) {

    switch (action.type) {

        case FETCHING_VENDORS_FROM_API: {
            return {
                ...state,
                fetching: true
            };
        }

        case GET_VENDORS_SUCCESS: {
            return {
                ...state,
                vendorList: action.vendors,
                fetching: false
            };
        }

        case GET_VENDORS_FAIL: {
            return {
                ...state
            };
        }

        case GET_FILTER_SUCCESS: {
            return {
                ...state,
                vendorFilterList: action.filters
            };
        }

        case GET_FILTER_FAIL: {
            return {...state};
        }

        case TOGGLE_INHERENT_RISK_FILTER: {

            return {
                ...state,
                vendorFilterList: {
                    ...state.vendorFilterList,
                    inherentRiskFilterOptions: state.vendorFilterList.inherentRiskFilterOptions
                        .map(x => x.name === action.riskFilterName
                                  ? {...x, isSelected: !x.isSelected}
                                  : x
                        )
                }
            };
        }

        case TOGGLE_RESIDUAL_RISK_FILTER: {
            return {
                ...state,
                vendorFilterList: {
                    ...state.vendorFilterList,
                    residualRiskFilterOptions: state.vendorFilterList.residualRiskFilterOptions
                        .map(x => x.name === action.riskFilterName
                                  ? {...x, isSelected: !x.isSelected}
                                  : x
                        )
                }
            };
        }

        case TOGGLE_BCP_FUNCTION_FILTER: {
            return {
                ...state,
                vendorFilterList: {
                    ...state.vendorFilterList,
                    functionFilterOptions: state.vendorFilterList.functionFilterOptions
                        .map(x => x.name === action.riskFilterName
                                  ? {...x, isSelected: !x.isSelected}
                                  : x
                        )
                }
            };
        }

        case TOGGLE_EVENT_FILTER: {
            return {
                ...state,
                vendorFilterList: {
                    ...state.vendorFilterList,
                    eventFilterOptions: state.vendorFilterList.eventFilterOptions
                        .map(x => x.name === action.eventFilterName
                                  ? {...x, isSelected: !x.isSelected}
                                  : x
                        )
                }

            };
        }

        case RESET_FILTER_ON_CLEAR_BUTTON_CLICK: {
            return {
                ...state,
                vendorFilterList: {
                    ...state.vendorFilterList,
                    [action.filterName]: state.vendorFilterList[action.filterName].map(x => {
                        return {...x, isSelected: false};
                    })
                }

            };
        }

        default: {
            return state;
        }
    }
}
